/* eslint-disable react-hooks/exhaustive-deps */
import { Typography } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import TagMappingsScreen from "../../components/TagMappings";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";
import { clamp } from "../../utils/responsiveHelpers";

const { Paragraph, Title } = Typography;

/**
 * Tag mappings across every product line in one place: each source's own tag,
 * our canonical tag for it, and whether an admin has decided the pairing.
 *
 * Product-line specifics stay off this screen. Choosing a type here narrows the
 * list; the fields that type records against a mapping are reached through a
 * row's metadata action, and are laid out as columns on that type's own
 * sub-page.
 *
 * Gated on the same access flag as External Problems, which is the only product
 * line keeping tag mappings today.
 */
const TagMappings = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  const { externalProblems: { hasAccess, hasManagementAccess = false } = {} } = userConfig ?? {};

  useEffect(() => {
    if (!hasAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <div style={{ padding: `${clamp(12, 24)} ${clamp(12, 24)} 0` }}>
        <Title level={4} style={{ marginBottom: 4 }}>
          Tag Mappings
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Every source describes content in its own words. A mapping records which of our canonical
          tags a source&apos;s tag means, so content tagged &quot;dp&quot; in one place and
          &quot;dynamic programming&quot; in another counts as the same thing everywhere.
        </Paragraph>
      </div>
      <TagMappingsScreen ROOT_URL={ROOT_URL} hasManagementAccess={hasManagementAccess} />
    </>
  );
};

export default TagMappings;
